import { render, staticRenderFns } from "./JTable.vue?vue&type=template&id=31395cae&scoped=true&"
import script from "./JTable.vue?vue&type=script&lang=ts&"
export * from "./JTable.vue?vue&type=script&lang=ts&"
import style0 from "./JTable.vue?vue&type=style&index=0&id=31395cae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31395cae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
